import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreTargetService } from '../../core/services/target.service';

export interface ShopifyLearningStatus {
  // Short label describing the current learning step (e.g. "Analyzing shopper behaviour").
  label: string;
  // Progress of the learning phase, 0 - 100.
  percentage: number;
  // Human readable estimate of the remaining time (e.g. "~1 day left").
  estimatedTimeLeftLabel: string;
  // Whether nudges & signals should switch on automatically once learning completes.
  autoActivate: boolean;
}

/**
 * Data source for the Shopify onboarding / "Learning Mode" dashboard.
 *
 * NOTE: The backend endpoints below do not exist yet. The methods are wired up
 * following the app's HTTP convention (env.address already contains `/api`, so
 * paths are relative) so they are ready to use the moment the endpoints ship.
 * See dashboard-shopify.component.ts for where these are (currently commented)
 * consumed.
 */
@Injectable({
  providedIn: 'root',
})
export class DashboardShopifyService {
  constructor(
    private http: HttpClient,
    private targetService: CoreTargetService,
  ) {}

  /** SET learning status for the selected store. */
  setLearningStatus(learningPhase: boolean): Observable<any> {
    const target = this.targetService.getSelectedTarget('target');
    return this.http.put<any>('/shopify/target-controls/learning-phase', {
      target,
      learningPhase,
    });
  }

  /** Persist the "auto-activate when ready" preference for the selected store. */
  setAutoActivate(enabled: boolean): Observable<any> {
    return this.http.put<any>('/shopify/target-controls/auto-activate', {
      target: this.targetService.getSelectedTarget('target'),
      autoActivate: enabled,
    });
  }

  /** Enable / disable Behamics (nudges & signals) for the selected store. */
  setBehamicsEnabled(deactivated: boolean): Observable<any> {
    return this.http.put<any>('/shopify/target-controls/deactivated', {
      target: this.targetService.getSelectedTarget('target'),
      deactivated,
    });
  }
}
